angular.module("vgresiduos").directive("destinationGathering", function () {
	return {
		scope: true,
		controller: "DestinationGatheringCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/stages/destinationGathering/destinationGathering_template.html"
	};
});
